module.exports = __webpack_public_path__ + "aetos-ai/static/img/avatar.90234cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/avatar.png
// module id = HfaK
// module chunks = 13